export class Loanreceipt {
    Id: number;
    LoanId: number;
    CustomerName : string;
    LoanAmount : number;
    ReceiptDate: Date;
    ReceiptAmount: number;
    PaymentId: number;
    CollectionAmount: number;
    ReceiptRemarks: number;
    EmployeeId: number;
    EmployeeBranchId: number;
    CompanyId: number;
    SaasId: number;
    CreatedDate: Date;
    ModifiedDate: Date;
    IsActive: Boolean;
    Flag : number;

    // for Report
        ReportName: string;
        FromDate: Date;
        ToDate : Date;
        BranchId: Number;
        CentreId: Number;
        loanCategoryId: Number;
}
